import { TVehicleProperty } from '../pages/home/properties/interfaces';

// REACT_APP_API_DOMAIN = 'lk-api2.manit.app',
// REACT_APP_API_DOMAIN = 'youon-api.me-interactive.net',

const {
  REACT_APP_API_DOMAIN = 'youon-api.me-interactive.net',
  REACT_APP_GOOGLE_API_KEY = '8cc65106-4ed1-4b48-afa1-c4e10938bcb8',
  PHONE_MASK = '+9 999 999 99 99',
} = process.env;

// const { protocol } = window.location;
const protocol = "https:";
const API_DOMAIN = `${protocol}//${REACT_APP_API_DOMAIN}`;

const API_SEARCH_LOCATION_URI = `https://geocode-maps.yandex.ru/1.x/?apikey=${REACT_APP_GOOGLE_API_KEY}`;

export { API_DOMAIN, API_SEARCH_LOCATION_URI, PHONE_MASK };

export const LOGIN_URL = 'api/user/login';
export const REGISTER_URL = 'api/_p/user/register';
export const LOGIN_PHONE_URL = '/api/users/code_register_sms';
export const LOGIN_BY_SMS = '/api/users/code_login';
export const ME_URL = 'api/me';
export const REQUEST_PASSWORD_URL = 'api/auth/forgot-password';
export const getRecoveryPasswordUrl = (email: string): string =>
  `/api/_p/reset_password/send_code?email=${email}`;
export const NEW_PASSWORD_URL = '/api/_p/change_password_from_link';

export const GET_USERS_URL = '/api/users';
export const createUserUrl = (country_code = 7, country_name = 'Russia'): string =>
  `/api/user/create?country_code=${country_code}&country_name=${country_name}`;
export const getUserUrl = (id: number | string): string => `/api/user/${id}`;
export const editUserUrl = (id: number, country_code = 7, country_name = 'Russia'): string =>
  `/api/user/${id}/edit?country_code=${country_code}&country_name=${country_name}`;
export const SEND_INVITE_URL = '/api/user_activate/send';
export const delUserUrl = (id: number): string => `/api/user/${id}`;

export const editStatusUrl = (id: number): string => `/api/user/${id}/status`;

export const GET_COMPANIES_URL = '/api/companies';
export const CREATE_COMPANY_URL = '/api/company';
export const SEARCH_COMPANY_URL = '/api/companies/search';
export const getCompanyUrl = (id: number): string => `/api/company/${id}`;
export const getCompanyManagersUrl = (id: number, page: number, perPage: number): string =>
  `/api/company/${id}/managers?page=${page}&per_page=${perPage}`;
export const delCompanyUrl = (id: number): string => `/api/company/${id}`;
export const editCompanyUrl = (id: number): string => `/api/company/${id}`;
export const uploadCompanyPhotoUrl = (company_id: number): string => `/api/companies/upload_photo?company_id=${company_id}`;

export const GET_ACTIVE_BRANDS_URL = 'api/active_brands';
export const GET_BRANDS_URL = 'api/brands';
export const GET_BRAND_URL = 'api/brand';

export const getModelsUrl: (id: number) => string = (id) => `api/brand/${id}/models`;
export const getModelByIdUrl: (id: number) => string = (id) => `api/model/${id}`;
export const addModelUrl: (id: number) => string = (id) => `api/brand/${id}/model`;
export const editModelUrl: (id: number) => string = (id) => `api/brand/model/${id}`;

export const getGenerationsUrl: (id: number) => string = (id) => `api/model/${id}/generations`;
export const getGenerationByIdUrl: (id: number) => string = (id) => `api/generation/${id}`;
export const addGenerationUrl: (id: number) => string = (id) => `api/model/${id}/generation`;
export const editGenerationUrl: (id: number) => string = (id) => `api/generation/${id}`;

export const getBodiesUrl: (id: number) => string = (id) =>
  `api/generation/${id}/body_configurations`;
export const getBodyByIdUrl: (id: number) => string = (id) => `api/body_configuration/${id}`;
export const addBodyUrl: (id: number) => string = (id) => `api/generation/${id}/body_generation`;
export const editBodyUrl: (id: number) => string = (id) => `api/body_configuration/${id}`;

export const getModificationsUrl: (id: number) => string = (id) =>
  `/api/body_configuration/${id}/modifications`;
export const getModificationByIdUrl: (id: number) => string = (id) => `/api/modification/${id}`;
export const addModificationUrl: (id: number) => string = (id) =>
  `/api/body_generation/${id}/modification`;
export const editModificationUrl: (id: number) => string = (id) => `/api/modification/${id}`;

export const uploadPhotoUrl = (modificationId: number): string =>
  `/api/modification/${modificationId}/upload_photos`;
export const delPhotoUrl = (id: number): string => `/api/photo/${id}`;
export const setMainPhotoUrl = (id: number): string => `/api/photo/${id}/set_main`;

export const getEquipmentsUrl = (modificationId: number): string =>
  `/api/modification/${modificationId}/complectations`;
export const getEquipmentByIdUrl = (id: number): string => `/api/complectation/${id}`;
export const addEquipmentUrl = (modificationId: number): string =>
  `/api/modification/${modificationId}/complectation`;
export const editEquipmentUrl = (id: number): string => `/api/complectation/${id}`;

export const getPropertiesUrl = (type: TVehicleProperty): string => `api/properties/${type}`;
export const addPropertyUrl = (type: TVehicleProperty): string => `api/property/${type}/`;
export const editPropertyUrl = (id: number): string => `api/property/${id}`;

export const getAdvantageUrl = (): string => `/api/advantage`;
export const editAdvantageUrl = (): string => `/api/advantage/edit`;

export const GET_OPTIONS_GROUPS_URL = '/api/equpment_groups/full';

export const CREATE_CATEGORY_URL = '/api/shop/category';
export const getCategoryUrl = (id: number | undefined) => `/api/shop/category/${id}`;
export const FULL_CATEGORIES_URL = '/api/shop/categories/full';
export const ROOT_CATEGORIES_URL = '/api/shop/categories/roots';
export const getCategoriesWithChildrenUrl = (id: number) => `/api/shop/category/${id}/children`;
export const getCategoriesWithParentUrl = (id: number) => `/api/shop/category/${id}/parents`;
export const getCategoriesPositionsUrl = (positions: string) =>
  `/api/shop/categories/set_positions?positions=${positions}`;
export const delPhotoFromCategory = (id: number) => `/api/shop/category_photo/${id}`;
export const delPhotoFromCompany = (id: number) => `/api/company/${id}/delete_logo`;
export const setCategoryMainPhotoUrl = (id: number): string =>
  `/api/shop/category_photo/${id}/set_main`;

export const PRODUCT_URL = '/api/shop/product';
export const PRODUCTS_URL = '/api/shop/products';
export const PRODUCTS_BANNERS_URL = '/api/shop/products_banners';
export const PRODUCTS_FAVORITES_URL = '/api/shop/products/favorites';
export const getProductByIdUrl = (id: number) => `/api/shop/product/${id}`;
export const getProductsByCategory = (id: number) => `/api/shop/category/${id}/products`;
export const delPhotoFromProduct = (id: number) => `/api/shop/product_photo/${id}`;
export const setProductMainPhotoUrl = (id: number): string =>
  `/api/shop/product_photo/${id}/set_main`;
export const setProductBannerPhotoUrl = (id: number): string =>
  `/api/shop/product_photo/${id}/set_banner `;

export const GET_CITIES_URL = '/api/cities';
export const ADD_CITIES_URL = '/api/city';
export const deleteCityByIdUrl = (id: number) => `/api/city/${id}`;

export const PRODUCT_TYPES_URL = '/api/shop/product_types';
export const getProductTypeByIdUrl = (id: number) => `/api/shop/product_type/${id}`;
export const PRODUCT_TYPE_URL = '/api/shop/product_type';
export const delProdyctTypeByIdUrl = (id: number) => `/api/shop/product_type/${id}`;

export const addParameterForType = (id: number) => `/api/shop/product_type/${id}/parameter`;
export const editParameterForType = (id: number) => `/api/shop/pproduct_type_parameter/${id}`;
export const getParametersForType = (id: number) => `/api/shop/product_type/${id}/parameters`;

export const getOrdersByStatus = (statuses: string) => `/api/shop/orders?statuses=${statuses}`;
export const getOrderurl = (id: number) => `/api/shop/order/${id}`;

export const STORES_URL = '/api/shop/stores';
export const CREATE_STORE_URL = '/api/shop/store';
export const getStoreByIdUrl = (id: number) => `api/shop/store/${id}`;

export const getTariffsUrl = '/api/tariffs';
export const editTariffDiscountsUrl = (id: number) => `/api/tariff/${id}`;
export const editTariffPriceUrl = (id: number) => `/api/tariff_price/${id}`;
export const editTariffPeriodUrl = (id: number) => `/api/tariff_period/${id}`;

export const editUserTariff = (userId: number, tariffId: number, days?: number) => {
  if (days) {
    return `/api/user_tariff?user=${userId}&tariff=${tariffId}&days=${days}`;
  } else {
    return `/api/user_tariff?user=${userId}&tariff=${tariffId}`;
  }
};

export const getReviewsUrl = (productId: number, perPage: number, page: number) =>
  `/api/shop/reviews/${productId}?page=${page}&per_page=${perPage}`;

export const delReviewUrl = (reviewId: number) => `/api/shop/review/${reviewId}`;

export const changeReviewUrl = (reviewId: number) => `/api/shop/review_status/${reviewId}`;
